<template>
  <component v-if="erpCamposIntegracao && this.currentComponent && hasFields"
             ref="camposIntegracao"
             v-bind:is="currentComponent"
             :form-data="formData"
             :dense="dense"
             :readonly="readonly"
             :full-width="fullWidth"
             :text-class="textClass"
             @replicar-campo="onReplicarCampo"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  computed: {
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    hasFields() {
      return this.formData && Object.keys(this.formData).length > 0;
    },
  },
  methods: {
    buildComponent() {
      if (!this.erpCamposIntegracao) {
        return;
      }
      const camposErp = this.erpCamposIntegracao.toLowerCase().replace('_', '-');
      this.currentComponent = `px-campos-${this.type}-${camposErp}`;
    },
    onReplicarCampo(obj) {
      this.$emit('replicar-campo', obj);
    },
  },
  watch: {
    erpCamposIntegracao(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.buildComponent();
    },
  },
  mounted() {
    this.buildComponent();
  },
};
</script>
